import { ReadClient, ReadConfig } from '../clients/ReadClient';
import ClientCallback from '../lib/clientCallback';
import { live } from '../clients/proto';
import { CallbackType } from '../const/common';
export interface TranslateReaderConfig {
  clientCallback?: ClientCallback;
  langCode: string;
  terminalInfo: live.ITerminalInfo;
  receivedMsgCallback?: (broadcastMsg) => void;
}

export default class TranslateReader {
  config: TranslateReaderConfig;
  readClient: ReadClient;
  clientCallback: ClientCallback;

  constructor(config: TranslateReaderConfig) {
    this.config = config;
  }

  start() {
    if (this.readClient) {
      this.readClient.continue();
    } else {
      const { langCode, terminalInfo, clientCallback } = this.config;
      const readConfig: ReadConfig = {
        langCode,
      };
      this.readClient = new ReadClient(
        readConfig,
        terminalInfo,
        this.handleClientCallback
      );
      if (clientCallback) {
        this.clientCallback = clientCallback;
      }
    }
  }

  stop() {
    this.readClient && this.readClient.stop();
  }

  restart(config?: TranslateReaderConfig) {
    if (this.readClient) {
      if (config) {
        const readConfig: ReadConfig = {
          langCode: config.langCode,
        };
        this.readClient.resetConfig(readConfig);
      }
      this.readClient.restartWs();
    }
  }

  setClientCallback(clientCallback: ClientCallback) {
    this.clientCallback = clientCallback;
  }

  setReceivedMsgCallback(callback: (broadcastMsg) => void) {
    if (this.clientCallback) {
      this.clientCallback.setReceiveMsgCallback(callback);
    }
  }

  handleClientCallback = (cbType: CallbackType, payload?: any) => {
    if (!this.clientCallback) {
      return;
    }
    switch (cbType) {
      case CallbackType.OPEN: {
        this.clientCallback.onOpenCallback();
        break;
      }
      case CallbackType.CLOSE: {
        const { code, message } = payload;
        this.clientCallback.onCloseCallback(code, message);
        break;
      }
      case CallbackType.FAIL: {
        const { code, message } = payload;
        this.clientCallback.onFailCallback(code, message);
        break;
      }
      case CallbackType.RECEIVE_MSG: {
        const { msg } = payload;
        this.clientCallback.onReceivedMsgCallback(msg);
        break;
      }
      default: {
        break;
      }
    }
  };
}
